
<template>
  <div>
    <template v-if="!wapShow">
    <header1 :menuIndex="5"></header1>
    <div class="news-banner">
      <div class="app-content">
        <div class="news-title">长期聚焦预应力的研究实践</div>
        <div class="news-detail">至善、使命、热爱、专注、硬科技，传递交达价值</div>
      </div>

    </div>
    <div class="new-box app-content" style="margin-top: 64px">
      <div class="new-header-img" style="cursor: pointer" @click="toPage(newList1)">
        <img :src="newList1.cover" style="width:100%;height:100%;object-fit: cover" />
        <div class="new-header-img-title">
          <p>{{newList1.title}}</p>
          <p style="margin-top: 21px">发布时间：{{newList1.publishDate}}</p>
        </div>
      </div>

      <div class="new-content" style="min-height: 600px">
        <div class="new-li"  v-for="item in list1" @click="toPage(item)">
          <p class="time1">{{getTimeMo(item.publishDate)}}</p>
          <p class="time2">{{getTimeMo1(item.publishDate)}}</p>
          <span class="new-span1">{{item.title}}</span>
          <span  class="new-span2" :title="item.subTitle">{{item.subTitle}}</span>
        </div>
      </div>
      <page style="margin-top: 40px" :selectIndex="selectIndex1" :pageIndex="pageIndex1" @last="selectIndex1--,getNewsList()" @next="selectIndex1++,getNewsList()"></page>
    </div>
    <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>


<script type="text/javascript">

  import header1 from "@/components/header1"
  import footers from "@/components/footers"
  import axios from "axios";
  import page from "@/components/page"
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../news/wapIndex";
  export default {
    name: 'news',
    components:{header1,footers,page,wapIndex},
    data(){
      return{
        list1:[],
        selectIndex1:1,
        pageIndex1:0,
        newList1:{
          publishDate:"",
          title:"",
          cover:"",
        },
        wapShow:false
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
        if(!this.wapShow) {
          this.getNewsList()
        }
      })

    },
    methods:{
      toPage(data){
        if(data.type=='outer'){
          window.open(data.url)
        }else if(data.type=='inner'){
          this.$router.push({
            path:'/newsDetail',
            query:{
              id:data.id
            }
          })
        }
      },
      getTimeMo(str){
        if(str){
          if(typeof str=="string"){
            str=str.replace(/-/g, '/');
          }
          let t1 = new Date(str)
          return ((t1.getDate())<10?('0'+(t1.getDate())):(t1.getDate()))
        }

        return ""
      },

      getTimeMo1(str){
        if(str){
          if(typeof str=="string"){
            str=str.replace(/-/g, '/');
          }
          let t1 = new Date(str)

          return t1.getFullYear()+"."+((t1.getMonth()+1)<10?('0'+(t1.getMonth()+1)):(t1.getMonth()+1))
        }

        return ""
      },
      getNewsList(){
        axios.get(this.pageUrl+`/news/page?pageNo=${this.selectIndex1}&pageSize=6`).then(res=>{
          this.pageIndex1=res.data.data.pages;
          if(this.selectIndex1==1){
            this.newList1=res.data.data.list[0];
            this.list1 = res.data.data.list.slice(1,res.data.data.list.length);
          }else {
            this.list1 = res.data.data.list;
          }


        })
      }
    }

  }
</script>

<style scoped>
  .news-banner{
    width: 100%;
    background-image: url("../../assets/imgs/news/3.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 560px;
    background-color: #F2F4F9;
    margin-top: 80px;

    background-position: 50% 50%;
    overflow: hidden;
  }
  .news-banner .news-title{
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 6px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    margin-left: 48px;
    margin-top: 90px;
    color: #19203B;
    animation-name: fadeInUp;

    animation-duration:1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
  }
  .news-banner .news-detail{
    font-size: 24px;
    letter-spacing: 4px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    margin-left: 48px;
    margin-top: 56px;
    animation-duration:1s;    opacity: 0;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    animation-name: fadeInUp;
    animation-delay: 1s;
    color: rgba(92, 93, 95, 1);
  }

  .new-box .new-header-img{
    width: 100%;
    height: 510px;
    position: relative;
    margin-bottom: 40px;
  }
  .new-box .new-header-img-title{
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 124px;
    font-size: 18px;
    padding: 32px 39px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    background-color: rgba(255, 255, 255, 0.56);
    box-sizing: border-box;
  }
  .new-box .new-content .new-li{
    width: 100%;
    box-sizing: border-box;
    padding: 24px 49px 0 120px;
    height: 100px;
    background: #F1F3F9;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-bottom: 19px;
    cursor: pointer;
    position: relative;
  }
  .new-box .new-content .new-li .time1{
    font-size: 44px;
    font-family: Titillium Web-Bold, Titillium Web;
    font-weight: bold;
    color: #0071EF;
    position: absolute;
    top: 10px;
    left: 43px;
  }

  .new-box .new-content .new-li .time2{
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    position: absolute;
    top: 68px;
    left: 45px;
  }
  .new-box .new-content .new-li:hover{
    background: linear-gradient(147deg, #34E4AA 0%, #2C68FF 100%);
  }
  .new-box .new-content .new-li:hover .new-span2, .new-box .new-content .new-li:hover .new-span1, .new-box .new-content .new-li:hover .time1,.new-box .new-content .new-li:hover .time2{
    color: #FFFFFF;
  }
  .new-box .title1{
    font-size: 40px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: center;
    margin: 64px 0 40px;
  }
  .new-box .new-content .new-span1{
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    display: block;
  }
  .new-box .new-content .new-span2{
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    line-height: 24px;
    display: block;
    margin-top: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/index.vue